import Vue from 'vue'
import VueRouter from 'vue-router'
import TabBar from '../views/tabbar/index.vue'
import Init from '../views/init/index.vue'
import Index from '../views/index/index.vue'
import Mine from '../views/mine/index.vue'
import Recharge from '../views/mine/recharge.vue'
import Preview from '../views/preview/index.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    meta:{
      auth: true
    },
    redirect: {
      name: 'TabIndex',
    },
  },
  {
    path: '/index',
    name: 'Index',
    component: TabBar,
    meta:{
      auth: true
    },
    children: [{
      path: '/tabIndex',
      name: 'TabIndex',
      meta:{
        auth: true
      },
      component: Index,
    }, {
      path: '/tabMine',
      name: 'TabMine',
      meta:{
        auth: true
      },
      component: Mine,
    }, ]
  },
  {
    path: '/mine',
    name: 'Mine',
    component: Mine,
    title: '个人中心',
    meta:{
      auth: true
    }
  },
  {
    path: '/collect',
    name: 'Collect',
    title: '我的收藏',
    meta:{
      auth: true
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/collect/index.vue')
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: Recharge,
    title: '充值中心',
    meta:{
      auth: true
    }
  },
  {
    path: '/preview/:id',
    name: 'Preview',
    component: Preview,
  },
  {
    path: '/login',
    name: 'Login',
    title:'希望保登录注册',
    component: () => import( /* webpackChunkName: "about" */ '../views/login/index.vue')
  },
  {
    path: '/detail',
    name: 'Detail',
    meta:{
      auth: true
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/detail/index.vue')
  },
  {
    path: '/sign',
    name: 'Sign',
    meta: {
      keepAlive: true
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/sign/index.vue')
  },
  {
    path: '/pay/pcpay',
    name: 'Pcpay',
    component: () => import( /* webpackChunkName: "about" */ '../views/paypc/index.vue')
  },
  {
    path: '/order',
    name: 'OrderList',
    title:'我的订单',
    meta:{
      auth: true
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/order/newList.vue')
  },
  {
    path: '/claim',
    name: 'Claim',
    title:'我要理赔',
    meta:{
      auth: true
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/claim/index.vue')
  },
  {
    path: '/fengxian',
    name: 'FengXian',
    title:'风险顾问',
    meta:{
      auth: true
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/mine/fengxian.vue')
  },
  {
    path: '/yanjiu',
    name: 'YanJiu',
    title:'风险研究院',
    meta:{
      auth: true
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/mine/yanjiu.vue')
  },
  {
    path: '/yanjiu/detail',
    name: 'YanJiuDetail',
    meta:{
      auth: true
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/mine/yanjiuDetail.vue')
  },
  {
    path: '/namelist',
    name: 'NameList',
    title:'名单列表',
    meta:{
      auth: true
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/mine/namelist.vue')
  },
  {
    path: '/nameWrite',
    name: 'NameWrite',
    // meta:{
    //   auth: true
    // },
    component: () => import( /* webpackChunkName: "about" */ '../views/mine/nameWrite.vue')
  },
  {
    path: '/nameDetail',
    name: 'NameDetail',
    meta:{
      auth: true
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/mine/nameDetail.vue')
  },
  {
    path: '/cpsorder',
    name: 'CpsOrder',
    meta: {
      keepAlive: true
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/order/cpsOrder.vue')
  },
  {
    path: '/order/detail',
    name: 'OrderDetail',
    component: () => import( /* webpackChunkName: "about" */ '../views/order/detail.vue')
  },
  // editorder
  {
    path: '/sign/editOrder',
    name: 'editOrder',
    component: () => import( /* webpackChunkName: "about" */ '../views/sign/editOrder.vue')
  },
  {
    path: '/cps/:iid',
    name: 'Cps',
    component: () => import( /* webpackChunkName: "about" */ '../views/cps/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
